const LEGAL_PATHS = Object.freeze({
    '/impressum': 'impressum',
    '/datenschutz': 'datenschutz',
    '/agb': 'agb',
    '/avv': 'avv'
});

const normalizePathname = (pathname = '/') => {
    const normalized = `/${String(pathname || '/')}`.replace(/\/{2,}/g, '/').replace(/\/+$/, '');
    return normalized || '/';
};

export const getLegalPageKey = (locationLike) => {
    const pathname = locationLike?.pathname ?? locationLike ?? '/';
    return LEGAL_PATHS[normalizePathname(pathname).toLowerCase()] || '';
};

export const isLegalPagePath = (locationLike) => Boolean(getLegalPageKey(locationLike));

export const LEGAL_PAGE_LINKS = Object.freeze([
    { key: 'impressum', path: '/impressum', label: 'Impressum' },
    { key: 'datenschutz', path: '/datenschutz', label: 'Datenschutz' },
    { key: 'agb', path: '/agb', label: 'B2B-AGB' },
    { key: 'avv', path: '/avv', label: 'AVV' }
]);
